import { AxiosError } from "axios";
import { useState } from "react";

import {
  QUOTE_JOURNEY_TYPE,
  QUOTE_CHANNEL_ONLINE,
  MEDICAL_REQUEST_ADD,
  MEDICAL_REQUEST_REDIRECT_URL,
  MEDICAL_REQUEST_EDIT,
  MedicalEdit,
} from "@/config/app-constant";
import { PRODUCT_DOMAIN } from "@/constants";
import axioInstance from "@/libs/axios";
import { QuoteData } from "@/types/quote/quote-data";

interface AddMedicalProps {
  referenceId?: string;
  travellerId?: string;
  version?: string;
  isEdit?: boolean;
  isPageEdit?: boolean;
}

type QuoteResponse = {
  data: {
    description: "Success" | string;
    data: QuoteData;
  };
};

export default function useMedicalConditions() {
  const [data, setMedicalResponse] = useState<null | QuoteData>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<null | AxiosError>(null);

  const patchMedicalConditions = async ({
    travellerId,
    referenceId,
    version,
    isEdit,
    isPageEdit,
  }: AddMedicalProps) => {
    const url = `${process.env.NEXT_PUBLIC_BASE_URL}/quote/${referenceId}/requestMedical`;
    const postBody = {
      data: {
        type: QUOTE_JOURNEY_TYPE,
        channel: QUOTE_CHANNEL_ONLINE,
        version,
        attributes: {
          domain: PRODUCT_DOMAIN,
          travellerDetails: {
            medicalTermsAndConditions: true,
            medicalRequest: {
              travellerEncryptedId: travellerId,
              action: isEdit ? MEDICAL_REQUEST_EDIT : MEDICAL_REQUEST_ADD,
              redirectUrl: isPageEdit
                ? `${MEDICAL_REQUEST_REDIRECT_URL}/?${MedicalEdit}=true`
                : MEDICAL_REQUEST_REDIRECT_URL,
            },
          },
        },
      },
    };

    try {
      setLoading(true);

      const response: QuoteResponse = await axioInstance.patch(url, postBody);

      setMedicalResponse(response.data?.data);
    } catch (err) {
      setError(err as AxiosError);
    } finally {
      setLoading(false);
    }
  };

  return { patchMedicalConditions, data, loading, error };
}
